export const Routes = {
  home: '/',
  services: '/services/',
  clients: '/clients/',
  about: '/about/',
  contact: '/contact/',
};
